/**
 * /frontend/src/features/analytics/components/shared/ExportCSVButton.js
 */

import React, { useCallback } from 'react';
import { downloadCsv } from '../../utils/csvExport';

/**
 * Export CSV button.
 * @param {{filename:string,rows:any[],label?:string,className?:string,title?:string}} props
 * @returns {JSX.Element}
 */
const ExportCSVButton = ({ filename, rows, label = 'Export CSV', className = '', title = '' }) => {
  const onClick = useCallback(
    () => downloadCsv(filename, rows || [], title ? { title } : {}),
    [filename, rows, title]
  );
  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      disabled={!rows || rows.length === 0}
    >
      {label}
    </button>
  );
};

export default ExportCSVButton;
